module.exports = __webpack_public_path__ + "img/jd_icon.dc3ae22.png";